import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SnippetService } from '../snippet.service';

@Component({
    selector: 'app-snippet-sortation',
    templateUrl: './snippet-sortation.component.html',
    styleUrls: ['./snippet-sortation.component.scss']
})
export class SnippetSortationComponent implements OnInit {
    @Input() snippets;
    @Output() modalAction: EventEmitter<any> = new EventEmitter<any>();

    toSave = [];

    constructor(
        private snippetService: SnippetService,
    ) {
    }

    ngOnInit() {
    }


    drop(e) {
        // moveItemInArray(this.images, event.previousIndex, event.currentIndex);
        this.toSave = e;
    }

    save() {
        const dataToEmit = {
            completed: true,
            sortation: this.toSave,
        };
        this.snippetService.saveSortation(this.toSave).subscribe(data => {
            this.modalAction.emit(dataToEmit);
        });
    }

    cancel() {
        const dataToEmit = {
            completed: false,
            sortation: this.snippets,
        };
        this.modalAction.emit(dataToEmit);
    }


}
